import IconDelete from '@mui/icons-material/Close'
import IconEdit from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton'
import { PlayIcon } from 'components/Icons'
import { Article, MyFile, Photo, Video, VIDEO_TYPE } from 'interfaces'
import { STOCK_PHOTO_TYPE, STOCK_VIDEO_TYPE } from 'interfaces/Content/StockContentTypes'
import { SelectableContent } from 'services/content/state'
import { PHOTO_TYPE } from 'shared'
import { isVideoUrl } from 'utils/composer'
import styles from './MiniContentCard.pcss'

const ICON_PLAY_SIZE = 40
const ICON_PLAY_SIZE_SMALL = 28

interface MiniContentCardProps {
  content: SelectableContent
  thumbUrl?: string
  onRemove: (id: string) => void
  onEditImage: (imageUrl: string) => void
  onClick: ({ imageUrl, videoUrl }: { imageUrl?: string, videoUrl?: string }) => void
}

export function MiniContentCard(props: MiniContentCardProps) {
  const { content, thumbUrl, onRemove, onEditImage, onClick } = props
  const imageUrl = thumbUrl || (content as Photo).thumbnailUrl || (content as Photo).imageUrl || (content as MyFile).thumbUrl

  const style = { backgroundImage: `url(${imageUrl})` }
  const isVideo = content.type === VIDEO_TYPE || content.type === STOCK_VIDEO_TYPE
  const isImage = [PHOTO_TYPE, STOCK_PHOTO_TYPE].includes(content.type)
  const title = (content as Article).title
  const videoUrl = isVideo ? (content as MyFile).url || (content as Video).videoUrl || '' : undefined

  const remove = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onRemove(content.id)
  }

  const edit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (imageUrl) {
      onEditImage(imageUrl)
    }
  }

  const click = () => {
    if (isVideo && isVideoUrl(videoUrl!)) {
      onClick({ videoUrl })
    } else if (imageUrl) {
      onClick({ imageUrl })
    }
  }

  return (
    <div className={styles.card} style={style} data-testid="mini-content-card" onClick={click}>
      <IconButton size="small" className={`${styles['btn-delete']} solid`} onClick={remove}>
        <IconDelete fontSize="small" />
      </IconButton>
      {isImage && (
        <IconButton size="small" className={`${styles['btn-edit']} solid`} onClick={edit}>
          <IconEdit fontSize="small" />
        </IconButton>
      )}
      {isVideo && (
        <PlayIcon
          size={title ? ICON_PLAY_SIZE_SMALL : ICON_PLAY_SIZE}
          className={`${styles['icon-play']} ${title ? styles.translate : ''}`}
        />
      )}
      {title && (
        <h3 className={styles.title}>{title}</h3>
      )}
    </div>
  )
}

export default MiniContentCard
